export default "__VITE_ASSET__AIkkX$a7__"